// extracted by mini-css-extract-plugin
export default {"buttonOpen":"OpenSidebarBtn_buttonOpen__fhMwo","iconMenu":"OpenSidebarBtn_iconMenu__ekwHO"};